import { useQuery } from '@apollo/client';

import { VALIDATOR_EVENT_USERS } from '../graphql/query/validatorEventUsersQuery.graphql';

export const useValidatorEventUsersQuery = (eventId: string | null) => {
  return useQuery(VALIDATOR_EVENT_USERS, {
    variables: { eventId: eventId ?? '' },
    skip: !eventId,
  });
};
